import { useProcessedImageUrl } from '#src/app/shared/hooks/image';

import type { Comment } from '../../../../../../../types';

type Result = ModelHookResult<{
	author: string;
	authorAvatar: string | undefined;
	authorUrl?: string;
	dateRelative: string;
}>;

export function useCommentHeader(comment: Comment): Result {
	const { user, createdAtRelativeLocalized } = comment;

	return {
		data: {
			author: user.displayName,
			authorAvatar: useProcessedImageUrl(user.photo?.userSmall),
			authorUrl: user.anonymous ? undefined : `/u/${encodeURIComponent(user.slug || user.id)}`,
			dateRelative: createdAtRelativeLocalized,
		},
	};
}
